import { RESSALVA } from './textoDoTrp'

/**
 * O carimbo do que este termo não traz.
 *
 * **Não é campo em branco, e a diferença é a entrega.** Quando o sistema não tem o dado, ele diz
 * que não tem e diz por quê — a mesma disciplina do indicador não apurado. Numa folha que vai para
 * processo administrativo isso vale ainda mais: ela circula solta, e quem a receber não terá esta
 * tela ao lado para perguntar por que a coluna de reais está vazia.
 *
 * Aparece **duas vezes** no documento, pelo mesmo motivo pelo qual a ressalva do RDM aparece
 * repetida: as folhas se separam.
 *
 * **Some quando o valor faturado está registrado**, e é isso que a torna informação e não decoração:
 * um carimbo que sai em toda emissão vira parte do papel e deixa de ser lido. Enquanto o valor não
 * existe, ela é a coisa mais importante da folha.
 *
 * @param props se o valor faturado da competência está por registrar
 * @returns o bloco da ressalva, ou nada
 */
export function RessalvaDoTrp({ semValorRegistrado }: { semValorRegistrado: boolean }) {
  if (!semValorRegistrado) {
    return null
  }

  return (
    <aside className="trp-ressalva">
      <p className="trp-ressalva-titulo">{RESSALVA.titulo}</p>
      <p>{RESSALVA.semReais}</p>
      <p>{RESSALVA.oQueOSistemaTem}</p>
      <p>{RESSALVA.aRessalvaDeLeitura}</p>
      <p>
        <strong>{RESSALVA.oQueFazer}</strong> {RESSALVA.semNumeroNaoEhZero}
      </p>
      <ul>
        {RESSALVA.outrosAusentes.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </aside>
  )
}
